module.exports = __webpack_public_path__ + "img/img-15.9b8c29d0.png";